import React from "react";
import { ShoppingBasket, User, LogOut, Phone } from "lucide-react";
import { useCart } from "../contexts/CartContext";
import { useAuth } from "../contexts/AuthContext";
import { Link, useNavigate } from "react-router-dom";

const LOGO = "https://customer-assets.emergentagent.com/job_spicy-combo-app/artifacts/n4fdqv2w_file_0000000003fc7246b07d96d6c45d39cd.png";
const PHONE = "07876664591";

export default function Header({ onSignInClick }) {
  const { count, setDrawerOpen } = useCart();
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-black/85 border-b border-border" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
          <img src={LOGO} alt="Loaded Street Kitchen" className="h-12 w-12 object-contain" />
          <div className="hidden sm:block">
            <div className="font-heading text-2xl tracking-wider leading-none text-cream">LOADED STREET</div>
            <div className="font-heading text-sm tracking-[0.3em] text-gold leading-none mt-1">KITCHEN</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 font-heading uppercase tracking-wider text-base text-cream/90">
          <a href="#combo" className="hover:text-gold transition-colors" data-testid="nav-combo">Combo Deal</a>
          <a href="#menu" className="hover:text-gold transition-colors" data-testid="nav-menu">Menu</a>
          <a href="#delivery" className="hover:text-gold transition-colors" data-testid="nav-delivery">Delivery</a>
          <a href={`tel:${PHONE}`} className="inline-flex items-center gap-2 text-gold hover:text-amber-400 transition-colors" data-testid="nav-phone">
            <Phone className="h-4 w-4" /> {PHONE}
          </a>
        </nav>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <button
                onClick={() => nav("/account")}
                className="inline-flex items-center gap-2 px-3 py-2 border-2 border-cream/40 text-cream font-heading uppercase tracking-wider text-sm hover:border-gold hover:text-gold transition-colors"
                data-testid="header-account-btn"
              >
                <User className="h-4 w-4" />
                <span className="hidden sm:inline">{user.name?.split(" ")[0] || "Account"}</span>
              </button>
              <button
                onClick={() => { logout(); nav("/"); }}
                className="inline-flex items-center px-2 py-2 border-2 border-cream/30 text-cream/70 hover:text-accent hover:border-accent transition-colors"
                title="Sign out"
                data-testid="header-logout-btn"
              >
                <LogOut className="h-4 w-4" />
              </button>
            </>
          ) : (
            <button
              onClick={onSignInClick}
              className="inline-flex items-center gap-2 px-3 py-2 border-2 border-cream/40 text-cream font-heading uppercase tracking-wider text-sm hover:border-gold hover:text-gold transition-colors"
              data-testid="header-signin-btn"
            >
              <User className="h-4 w-4" />
              <span className="hidden sm:inline">Sign In</span>
            </button>
          )}
          <button
            onClick={() => setDrawerOpen(true)}
            className="relative inline-flex items-center gap-2 px-3 sm:px-4 py-2 border-2 border-gold text-gold font-heading uppercase tracking-wider hover:bg-gold hover:text-black transition-colors"
            data-testid="open-cart-btn"
          >
            <ShoppingBasket className="h-5 w-5" />
            <span className="hidden sm:inline">Basket</span>
            {count > 0 && (
              <span className="absolute -top-2 -right-2 bg-accent text-white font-heading text-sm h-6 min-w-[1.5rem] px-1 flex items-center justify-center" data-testid="cart-count-badge">
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
}
